import React from 'react';

function ErrorNotFound() {  

  return (
    <div className='theme-yellow' style={{height:'100vh'}}>    
      <div className='Page-wrap flex-center' style={{height:'100vh'}}>
          <div className='t-c'>
              <img src='/img/404.png' />
              <div className='rounded p-2 bg-white mt-1 shadow' style={{maxWidth:'600px'}}>
                  <div className='p-1'>
                    <h3  className=' p-0 mb-3 text-center' style={{color:'Crimson', marginTop:'0'}}>Page Not Found</h3>
                    <p  className='mb-2'>We're sorry, but the Page with the provided code is not found in our system. The Page code you entered is incorrect, and as a result, we are unable to load the Page.</p>
                    <p>Please double-check the Page code you've entered and try again. If you believe this is an error, or if you need assistance, please click the following button for report a problem. Thank you for your understanding.</p>                
                  </div>
              </div>
              <div className='drawer-box text-center'>
                  <a className='button mt-1 bg-theme-accent text-white p-3 rounded mt-2 fs-6'  style={{display:'inline-block'}} href='/'> Go to Home</a>
                </div>
          </div>
      </div>
    </div>
  );
}

export default ErrorNotFound;
